import { render } from "./TrainConfigurations.vue?vue&type=template&id=330e35f1"
import script from "./TrainConfigurations.vue?vue&type=script&lang=js"
export * from "./TrainConfigurations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__